import { Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileTypeEnum } from "../../_common/enum";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { CaseTicketUploadManage } from "./_components/ticket-caseTicketsUploadManage";

export const CaseTicketsUplaodDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            //sx={{ //if we need to increase the size of the drawer
            //'& .MuiDrawer-paper.MuiDrawer-paperAnchorRight': {
            //width: '600px !important'
            //}
            //}}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Upload Case Tickets File"} onClose={params.onClose} />

            <CaseTicketUploadManage fileType={FileTypeEnum.Case} onSave={params.onSave} onClose={params.onClose} />

        </Drawer>
    );
};